import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute: React.FC = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [waitingForAuth, setWaitingForAuth] = useState(true);

  useEffect(() => {
    console.log('PrivateRoute - Auth state:', { user: !!user, loading });
    
    // Set a timeout to stop waiting for auth after 3 seconds
    // This prevents infinite loading if there's an issue with Firebase
    const timeoutId = setTimeout(() => {
      if (waitingForAuth) {
        console.log('Auth timeout reached, stopping waiting for auth');
        setWaitingForAuth(false);
      }
    }, 3000);
    
    // If auth is no longer loading, we don't need to wait anymore
    if (!loading) {
      setWaitingForAuth(false);
      clearTimeout(timeoutId);
    }
    
    return () => clearTimeout(timeoutId);
  }, [user, loading, waitingForAuth]);

  // If the authentication is still loading and we're still waiting, show a loading spinner
  if ((loading || !user) && waitingForAuth) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4"></div>
        <p className="text-gray-600">Loading authentication...</p>
        <p className="text-sm text-gray-500 mt-2">If this takes too long, try refreshing the page</p>
      </div>
    );
  }

  // If the user is not authenticated and we're done waiting, redirect to login
  if (!user) {
    console.log('User not authenticated, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If the user is authenticated, render the child routes
  console.log('User authenticated, rendering protected content');
  return <Outlet />;
};

export default PrivateRoute;
